import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useCustomerAuth } from '../contexts/CustomerAuthContext';
import ChangePasswordGate from './ChangePasswordGate';

interface CustomerProtectedRouteProps {
  children: React.ReactNode;
}

const CustomerProtectedRoute: React.FC<CustomerProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, loading, mustChangePassword, changePassword, logout, user } =
    useCustomerAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    // Redirect to customer login, preserving the intended destination
    return <Navigate to="/customer/login" state={{ from: location }} replace />;
  }

  // Contrato F1: mientras arrastre la contraseña de un solo uso NO se pinta
  // ninguna ruta del portal — ni datos, ni layout. Va aquí (y no en cada
  // página) porque TODA ruta protegida pasa por este guard; el login, el
  // registro y la landing son públicos y quedan fuera a propósito.
  if (mustChangePassword) {
    return (
      <ChangePasswordGate
        email={user?.email}
        onSubmit={changePassword}
        onCancel={logout}
      />
    );
  }

  return <>{children}</>;
};

export default CustomerProtectedRoute;

